var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[_c('div',{staticClass:"profile-card"},[_c('avatar-skeleton'),_c('fields-skeleton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }